import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';

import { HttpErrorResponse } from '@angular/common/http';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { IGlobalSettings, IGlobalSettingsSaveResponse, IOrderTypeDefault } from '@irb/irb-settings/irb-settings.model';
import { AppService } from '@irb/app.service';
import { IEvent, IrbSettingsEvents, IrbAppEvents } from '@irb-common/events';
import { PageService } from '@irb-common/services/page.service';
import { Subscription, Observable, of } from 'rxjs';
import { UIDropDownDTO, DollarRoundingDropDown, ShareRoundingDropDown, PriceTypeDropDown } from './settings-orders.model';
import { SettingsPage } from '@irb/irb-settings/irb-settings.page';
import { IrbAuthenticationService } from '@irb/irb-authentication/irb-authentication.service';
import {InventoryService} from "@irb/irb-orders/order-blotter/inventory/inventory.service";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
  selector: 'irb-settings-orders',
  templateUrl: './settings-orders.component.html',
  styleUrls: ['./settings-orders.component.scss', '../../irb-common/styles/dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SettingsOrdersComponent implements SettingsPage<IGlobalSettings>, OnInit, OnDestroy {
  @ViewChild('sendTaxLotInfoToVEOYes') sendTaxLotInfoToVEOYes: any;
  @ViewChild('sendTaxLotInfoToVEONo') sendTaxLotInfoToVEONo: any;
  @ViewChild('isSolicited') isSolicited: any;
  @ViewChild('isDiscretionary') isDiscretionary: any;
  @ViewChild('isMfSellAmtTypeDollarsTrue') isMfSellAmtTypeDollarsTrue: any;
  @ViewChild('isMfSellAmtTypeDollarsFalse') isMfSellAmtTypeDollarsFalse: any;
  @ViewChild('isAddToNetAmountYes') isAddToNetAmountYes: any;
  @ViewChild('isAddToNetAmountNo') isAddToNetAmountNo: any;
  @ViewChild('isEquitySellOrderTypeMarketYes') isEquitySellOrderTypeMarketYes: any;
  @ViewChild('isEquitySellOrderTypeMarketNo') isEquitySellOrderTypeMarketNo: any;
  @ViewChild('isEquityBuyOrderTypeMarketYes') isEquityBuyOrderTypeMarketYes: any;
  @ViewChild('isEquityBuyOrderTypeMarketNo') isEquityBuyOrderTypeMarketNo: any;
  @ViewChild('isOptionsSellOrderTypeMarketYes') isOptionsSellOrderTypeMarketYes: any;
  @ViewChild('isOptionsSellOrderTypeMarketNo') isOptionsSellOrderTypeMarketNo: any;
  @ViewChild('isOptionsBuyOrderTypeMarketYes') isOptionsBuyOrderTypeMarketYes: any;
  @ViewChild('isOptionsBuyOrderTypeMarketNo') isOptionsBuyOrderTypeMarketNo: any;
  @ViewChild('isShareRoundingYes') isShareRoundingYes: any;
  @ViewChild('isShareRoundingNo') isShareRoundingNo: any;
  @ViewChild('isDollarRoundingNo') isDollarRoundingNo: any;
  @ViewChild('isDollarRoundingYes') isDollarRoundingYes: any;

  @ViewChild('iRbDollarRoundingSettingDD') iRbDollarRoundingSettingDD: any;
  @ViewChild('iRbShareRoundingSettingDD') iRbShareRoundingSettingDD: any;
  @ViewChild('iRbEquitySellDD') iRbEquitySellDD: any;
  @ViewChild('iRbEquityBuyDD') iRbEquityBuyDD: any;
  @ViewChild('iRbOptionSellDD') iRbOptionSellDD: any;
  @ViewChild('iRbOptionBuyDD') iRbOptionBuyDD: any;

  _globalSettings: IGlobalSettings;
  originalGlobalSettings: IGlobalSettings;
  _isModified: boolean;
  eventSubscription: Subscription;
  showUnsavedChangesWarning: boolean = false;
  _dollarRoundingSetting: UIDropDownDTO;
  _shareRoundingSetting: UIDropDownDTO;

  _dollarRoundingDropDown: DollarRoundingDropDown;
  _shareRoundingDropDown: ShareRoundingDropDown;
  _priceTypeDropDown: PriceTypeDropDown;

  isDollarRounding: boolean = false;
  isShareRounding: boolean = false;

  equitySellOrderTypeDefault: UIDropDownDTO;
  equitySellActionTypeDefault: IOrderTypeDefault;

  equityBuyOrderTypeDefault: UIDropDownDTO;
  equityBuyActionTypeDefault: IOrderTypeDefault;

  optionsSellOrderTypeDefault: UIDropDownDTO;
  optionsSellActionTypeDefault: IOrderTypeDefault;

  optionsBuyOrderTypeDefault: UIDropDownDTO;
  optionsBuyActionTypeDefault: IOrderTypeDefault;
  defaultExpandedPanels:Array<string>=["HISTORY","ROUNDING_OPTIONS","VERSUS_PURCHASE_INSTRUCTIONS","MUTUAL_FUND_RULES","ORDER_TYPE_DEFAULTS","ORDER_AUTHORIZATIONS"];
  errors: Array<string>;
  isadmin:boolean=false;
  validationErrors: string[];
  validationErrorTemplates: TemplateRef<any>[];
  ENABLE_SETTINGS_HIST: boolean;
  ENABLE_FRACTIONAL_SHARES: boolean;

  constructor(
    public iss: IrbSettingsService,
    private cdr: ChangeDetectorRef,
    private util: UtilityService,
    private as: AppService,
    private ps: PageService,
    public ias :IrbAuthenticationService,
    public ats: AnalyticsService) {
      this.ats.trackGlobalSettingsTradingEvent();
      this.eventSubscription = this.as.getEvents().subscribe((s) => { this.processEvent(s); });
      this.ENABLE_SETTINGS_HIST = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_SETTINGS_HIST || false;
      this.ENABLE_FRACTIONAL_SHARES = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_FRACTIONAL_SHARES || false;
  }

  ngOnInit() {
    this.ias.getAppConfigDetails().subscribe((data:any)=>{
        this.isadmin=data.isAdmin;
    });
   //this.isadmin=false;
    this.ps.deserializePageState(this.as.getFromSession("pageState"), ["orderGridDiv"]);
    if (!this.ENABLE_SETTINGS_HIST) {
      this.defaultExpandedPanels = this.defaultExpandedPanels.filter(p => p !== 'HISTORY');
    }
    this.iss.loadExpansionState(this.defaultExpandedPanels.length, "settings-orders",this.defaultExpandedPanels);
    if (this.ENABLE_SETTINGS_HIST) {
      this.iss.updateExpansionState('HISTORY','closed');
    }
    this.cdr.detectChanges();

    this.iss.getDollarRoundingDropDown().subscribe((data: any) => {
      this.loadDollarRoundingDropDown(data as DollarRoundingDropDown);

      this.iss.getShareRoundingDropDown().subscribe((data: any) => {
        this.loadShareRoundingDropDown(data as ShareRoundingDropDown);

        this.iss.getPriceTypeDropDown().subscribe((data: any) => {
          this.loadPriceTypeDropDown(data as PriceTypeDropDown);

          this.iss.getGlobalSettings().subscribe((data: any) => {
            this.load(data as IGlobalSettings);
          });
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.eventSubscription.unsubscribe();
  }

  onInputChange() {
    window.setTimeout(() => {
      this.isModified = !this.util.compare(this.originalGlobalSettings, this.globalSettings);
      this.as.fireEvent((this.isModified) ? IrbSettingsEvents.IS_MODIFIED : IrbSettingsEvents.IS_NOT_MODIFIED);
      this.showUnsavedChangesWarning = false;
      this.cdr.detectChanges();
      this.validateInput().subscribe(validationErrors => {
        if(validationErrors.length > 0) {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              severity: 'error',
              summary: 'Save',
              detail: validationErrors[0]
          });
        }
      });
    });
  }

  onInputChangeForLimitType(isLimitTypeSelected: boolean) {
    if (isLimitTypeSelected) {
      this.onInputChange();
    } else {
      window.setTimeout(() => {
        this.showUnsavedChangesWarning = false;
        this.cdr.detectChanges();
        this.validateInput().subscribe(validationErrors => {
          if (validationErrors.length > 0) {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'Save',
                detail: validationErrors[0]
            });
          }
        });
      });
    }
  }

  setiRbDollarRoundingSettingDD(searchStr: any) {
    this.iRbDollarRoundingSettingDD.set(DropdownFilterComponent.getFilteredList(searchStr, this.dollarRoundingDropDown.items));
  }

  setiRbShareRoundingSettingDD(searchStr: any) {
    this.iRbShareRoundingSettingDD.set(DropdownFilterComponent.getFilteredList(searchStr, this.shareRoundingDropDown.items));
  }

  setiRbEquitySellDD(searchStr: any) {
    this.iRbEquitySellDD.set(DropdownFilterComponent.getFilteredList(searchStr, this.priceTypeDropDown.items));
  }

  setiRbEquityBuyDD(searchStr: any) {
    this.iRbEquityBuyDD.set(DropdownFilterComponent.getFilteredList(searchStr, this.priceTypeDropDown.items));
  }

  setiRbOptionSellDD(searchStr: any) {
    this.iRbOptionSellDD.set(DropdownFilterComponent.getFilteredList(searchStr, this.priceTypeDropDown.items));
  }

  setiRbOptionBuyDD(searchStr: any) {
    this.iRbOptionBuyDD.set(DropdownFilterComponent.getFilteredList(searchStr, this.priceTypeDropDown.items));
  }

  onDollarRoundingChange() {
    this.globalSettings.dollarRoundingSetting = this.dollarRoundingSetting.name;

    /* if (this.isDollarRounding) {
      if (this.globalSettings.dollarRoundingSetting != 'None') {
        this.onInputChange();
      }
    } else {
      this.globalSettings.dollarRoundingSetting = 'None';
      this.resetDropdDowns();
      this.onInputChange();
    } */
    if (!this.isDollarRounding) {
      this.globalSettings.dollarRoundingSetting = 'None';
      this.resetDropdDowns();
    }

    this.onInputChange();
  }

  onShareRoundingChange() {
    this.globalSettings.shareRoundingSetting = this.shareRoundingSetting.name;
    
    /* if (this.isShareRounding) {
      if (this.globalSettings.shareRoundingSetting != 'None (Fractional)') {
        this.onInputChange();
      }
    } else {
      this.globalSettings.shareRoundingSetting = 'None (Fractional)';
      this.resetDropdDowns();
      this.onInputChange();
    } */
    if (!this.isShareRounding) {
      this.globalSettings.shareRoundingSetting = 'None';
      this.resetDropdDowns();
    }

    this.onInputChange();
  }

  onOrderTypeDefaultsChange() {
    this.globalSettings.orderTypeDefaultList.forEach(orderTypeDefault => {
      switch(orderTypeDefault.defaultActionType.toLowerCase()) {
        case 'equity sells':
          orderTypeDefault.defaultOrderType = this.equitySellActionTypeDefault.defaultOrderType;
          this.equitySellOrderTypeDefault = this.getPriceType(this.equitySellOrderTypeDefault, orderTypeDefault.defaultOrderType);
          orderTypeDefault.deafultPriceType = (this.equitySellOrderTypeDefault) ? this.equitySellOrderTypeDefault.name : null;
          break;
        case 'equity buys':
          orderTypeDefault.defaultOrderType = this.equityBuyActionTypeDefault.defaultOrderType;
          this.equityBuyOrderTypeDefault = this.getPriceType(this.equityBuyOrderTypeDefault, orderTypeDefault.defaultOrderType);
          orderTypeDefault.deafultPriceType = (this.equityBuyOrderTypeDefault) ? this.equityBuyOrderTypeDefault.name : null;  
          break;
        case 'options sell':
          orderTypeDefault.defaultOrderType = this.optionsSellActionTypeDefault.defaultOrderType;
          this.optionsSellOrderTypeDefault = this.getPriceType(this.optionsSellOrderTypeDefault, orderTypeDefault.defaultOrderType);
          orderTypeDefault.deafultPriceType = (this.optionsSellOrderTypeDefault) ? this.optionsSellOrderTypeDefault.name : null;
          break;
        case 'options buy':
          orderTypeDefault.defaultOrderType = this.optionsBuyActionTypeDefault.defaultOrderType;
          this.optionsBuyOrderTypeDefault = this.getPriceType(this.optionsBuyOrderTypeDefault, orderTypeDefault.defaultOrderType);
          orderTypeDefault.deafultPriceType = (this.optionsBuyOrderTypeDefault) ? this.optionsBuyOrderTypeDefault.name : null;
          break;
      }
    });

    this.onInputChange();
  }

  getPriceType(u: UIDropDownDTO, orderType: string): UIDropDownDTO {
    if(orderType == "Market") {
      return null;
    } else {
      return (u) ? u : this.priceTypeDropDown.items[0];
    }
  }

  resetDropdDowns() {
    this.dollarRoundingDropDown.items.forEach((item: any) => {
      item.value = item.id;
      if(item.name == this.globalSettings.dollarRoundingSetting) {
        this.dollarRoundingSetting = { 
          name: this.globalSettings.dollarRoundingSetting,
          id: item.id,
          value: item.id,
          versionId: null
        } as UIDropDownDTO;
      }
    });

    this.shareRoundingDropDown.items.forEach((item: any) => {
      item.value = item.id;
      if(item.name.startsWith(this.globalSettings.shareRoundingSetting)) {
        this.shareRoundingSetting = { 
          name: item.name,
          id: item.id,
          value: item.id,
          versionId: null
        } as UIDropDownDTO;
      }
    });
  }

  load(data: IGlobalSettings) {
    this.globalSettings = data;
    this.globalSettings.shareRoundingSetting = this.globalSettings.shareRoundingSetting || 'None';

    if(this.ENABLE_FRACTIONAL_SHARES && this.globalSettings.shareRoundingSetting == 'None') {
      this.globalSettings.shareRoundingSetting = "None (Fractional)";
    }

    this.globalSettings.currentSetting = "tradeView";
    this.originalGlobalSettings = this.util.clone(this.globalSettings);
    this.isModified = false;
    this.showUnsavedChangesWarning = false;
    this.as.fireEvent(IrbSettingsEvents.IS_NOT_MODIFIED);
    this.resetDropdDowns();

    const dollarRounding: string = this.globalSettings.dollarRoundingSetting;
    if (dollarRounding.toUpperCase() == 'NONE') {
      this.isDollarRounding = false;
    } else {
      this.isDollarRounding = true;
    }

    const shareRounding: string = this.globalSettings.shareRoundingSetting;
    if (shareRounding.toUpperCase().startsWith('NONE')) {
      this.isShareRounding = false;
    } else {
      this.isShareRounding = true;
    }

    if (this.globalSettings.orderTypeDefaultList == null || this.globalSettings.orderTypeDefaultList.length == 0) {
      this.globalSettings.orderTypeDefaultList = [];
      this.globalSettings.orderTypeDefaultList.push(this.getOrderTypeDefault("Equity Sells"));
      this.globalSettings.orderTypeDefaultList.push(this.getOrderTypeDefault("Equity Buys"));
      this.globalSettings.orderTypeDefaultList.push(this.getOrderTypeDefault("Options Sell"));
      this.globalSettings.orderTypeDefaultList.push(this.getOrderTypeDefault("Options Buy"));
      this.originalGlobalSettings.orderTypeDefaultList = this.util.clone(this.globalSettings.orderTypeDefaultList);
    }

    this.globalSettings.orderTypeDefaultList.forEach(orderTypeDefault => {
      switch(orderTypeDefault.defaultActionType.toLowerCase()) {
        case 'equity sells':
          this.equitySellActionTypeDefault = orderTypeDefault;
          this.equitySellOrderTypeDefault = this.transformToUIDropDownDTO(orderTypeDefault);
          break;
        case 'equity buys':
          this.equityBuyActionTypeDefault = orderTypeDefault;
          this.equityBuyOrderTypeDefault = this.transformToUIDropDownDTO(orderTypeDefault);
          break;
        case 'options sell':
          this.optionsSellActionTypeDefault = orderTypeDefault;
          this.optionsSellOrderTypeDefault = this.transformToUIDropDownDTO(orderTypeDefault);
          break;
        case 'options buy':
          this.optionsBuyActionTypeDefault = orderTypeDefault;
          this.optionsBuyOrderTypeDefault = this.transformToUIDropDownDTO(orderTypeDefault);
          break;
      }
    });
    
    this.cdr.detectChanges();
  }

  transformToUIDropDownDTO(orderTypeDefault: IOrderTypeDefault): UIDropDownDTO {
    for(let i = 0; i < this.priceTypeDropDown.items.length; i++) {
      this.priceTypeDropDown.items[i].value = this.priceTypeDropDown.items[i].id;
      if(this.priceTypeDropDown.items[i].name == orderTypeDefault.deafultPriceType) {
        return this.priceTypeDropDown.items[i];
      }
    }

    return null;
  }

  getOrderTypeDefault(defaultActionType: string): IOrderTypeDefault {
    return {
      orderTypeDefaultId: null,
      defaultActionType: defaultActionType,
      defaultOrderType: "Market",
      deafultPriceType: null
    };
  }

  loadDollarRoundingDropDown(data: DollarRoundingDropDown) {
    this.dollarRoundingDropDown = data;
    this.cdr.detectChanges();
  }

  loadShareRoundingDropDown(data: ShareRoundingDropDown) {
    this.shareRoundingDropDown = data;
    this.cdr.detectChanges();
  }

  loadPriceTypeDropDown(data: PriceTypeDropDown) {
    this.priceTypeDropDown = data;
    this.cdr.detectChanges();
  }

  processEvent(event: IEvent) {
    switch (event.type) {
      case IrbSettingsEvents.SAVE:
        this.save();
        break;
      case IrbSettingsEvents.UNSAVED_CHANGES:
        if (this.isModified) {
          this.showUnsavedChangesWarning = true;
          this.cdr.detectChanges();
        }
        break;
      case IrbSettingsEvents.REVERT_CHANGES:
        this.revert();
        break;
    }
  }

  revert() {
    if (this.isModified) {
      this.load(this.originalGlobalSettings);
    }
  }

  save() {
    this.validateInput().subscribe(validationErrors => {
      if (validationErrors.length === 0) {
        this.as.fireEvent(IrbSettingsEvents.SAVE_START);
        
        if(this.globalSettings.shareRoundingSetting == 'None (Fractional)') {
          this.globalSettings.shareRoundingSetting = "None";
        }

        this.iss.saveTradingGlobalSettings(this.globalSettings).subscribe((data: any) => {
          const response = data as IGlobalSettingsSaveResponse;

          if (response.responseStatus == "SUCCESS") {
              this.iss.getGlobalSettings().subscribe((data: any) => {
                this.as.fireEvent(IrbSettingsEvents.SAVE_SUCCESS, "Trading settings were updated.");
                this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
                this.load(data as IGlobalSettings);
              });              
          } else {
            this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
          }
        }, () => {
          this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
        });
      } else {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Save',
            detail: this.validationErrors[0]
        });
      }
    });
  }

  validateInput(): Observable<string[]> {
    this.validationErrors = [];
    this.validationErrorTemplates = [];

    if (this.equitySellActionTypeDefault.defaultActionType === 'Limit' && this.equitySellOrderTypeDefault.name == null) {
      this.validationErrors.push("Please select price limit type for equity sell order");
    }

    if (this.equityBuyActionTypeDefault.defaultActionType === 'Limit' && this.equityBuyOrderTypeDefault.name == null) {
      this.validationErrors.push("Please select price limit type for equity buy order");
    }

    if (this.optionsSellActionTypeDefault.defaultActionType === 'Limit' && this.optionsSellOrderTypeDefault.name == null) {
      this.validationErrors.push("Please select price limit type for options sell order");
    }

    if (this.optionsBuyActionTypeDefault.defaultActionType === 'Limit' && this.optionsBuyOrderTypeDefault.name == null) {
      this.validationErrors.push("Please select price limit type for options buy order");
    }

    return of(this.validationErrors);
  }

  get globalSettings() {
    return this._globalSettings;
  }

  set globalSettings(newGlobalSettings: IGlobalSettings) {
    this._globalSettings = newGlobalSettings;
  }

  get isModified() {
    return this._isModified;
  }

  set isModified(newIsModified: boolean) {
    this._isModified = newIsModified;
  }

  get dollarRoundingDropDown() {
    return this._dollarRoundingDropDown;
  }

  set dollarRoundingDropDown(newDollarRoundingDropDown: DollarRoundingDropDown) {
    this._dollarRoundingDropDown = newDollarRoundingDropDown;
  }

  get dollarRoundingSetting(): UIDropDownDTO {
    return this._dollarRoundingSetting;
  }

  set dollarRoundingSetting(d: UIDropDownDTO)  {
    this._dollarRoundingSetting = d;
  }

  get shareRoundingSetting(): UIDropDownDTO {
    return this._shareRoundingSetting;
  }

  set shareRoundingSetting(d: UIDropDownDTO)  {
    this._shareRoundingSetting = d;
  }

  get shareRoundingDropDown() {
    return this._shareRoundingDropDown;
  }

  set shareRoundingDropDown(newShareRoundingDropDown: ShareRoundingDropDown) {
    this._shareRoundingDropDown = newShareRoundingDropDown;
  }

  get priceTypeDropDown() {
    return this._priceTypeDropDown;
  }

  set priceTypeDropDown(newPriceTypeDropDown: PriceTypeDropDown) {
    this._priceTypeDropDown = newPriceTypeDropDown;
  }
}
